@if (errorMessage()) {
  <div class="errorMessage">
    <pre>{{ errorMessage() }}</pre>
  </div>
}
<div class="content">
  @if (task()) {
    <div class="taskDetail">
      <div class="taskMessage">
        <p>This task has been assigned because this order requires samples of Customer Furnished Parts.
        It should not be closed until all required samples have been received and approved</p>
        <p class="importantText">
          Please verify that all required samples have been received and are in acceptable condition before
          closing this task
        </p>
      </div>
      <div class="displayRow">
        <label class="inputLabel">Task Name:</label>
        <label class="displayLabel">{{ task().name }}</label>
      </div>
      <div class="displayRow">
        <label class="inputLabel">Started:</label>
        <label class="displayLabel">{{ task().startTime | date: 'M/d/yyyy hh:mm a' }}</label>
      </div>
      @if (task().escalationTime) {
        <div class="displayRow">
          <label class="inputLabel">Will Escalate:</label>
          <label class="displayLabel">{{ task().escalationTime | date: 'M/d/yyyy hh:mm a' }}</label>
        </div>
      }
      @if (task().autoCompleteTime) {
        <div class="displayRow">
          <label class="inputLabel">Will Autocomplete:</label>
          <label class="displayLabel">{{ task().autoCompleteTime | date: 'M/d/yyyy hh:mm a' }}</label>
        </div>
      }
      <div class="displayRow">
        <label class="inputLabel">Assigned To:</label>
        <label class="displayLabel">{{ assignedTo() }}</label>
      </div>
    </div>
  }
  @if (entity()) {
    <div class="entityDetail">
      <div class="displayRow">
        <label class="inputLabel">Entity ID:</label>
        <label class="displayLabel">{{ entity().id.entityId + ';' + entity().id.entityRevision }}</label>
      </div>
      <div class="displayRow">
        <label class="inputLabel">Project:</label>
        <label class="displayLabel">{{ entity().projectName }}</label>
      </div>
    </div>
  }
  @if (canCloseTask()) {
    <div class="responseInput">
      <label class="inputLabel"></label>
      <input class="checkboxInput" type="checkbox" id="verifyInput" [(ngModel)]="isAccepted"/>
      <label class="checkboxLabel" for="verifyInput">IEC has received the required samples and they are in
      satisfactory condition</label>
    </div>
  }
  @if (canCloseTask()) {
    <div class="buttonRow">
      <label class="inputLabel"></label>
      <button matButton="elevated" class="buttonInput approveButton" [disabled]="!isAccepted" (click)="closeTask(true)">
        <span>
          <mat-icon class="size-16">done</mat-icon>
          <label class="buttonLabel">Approve</label>
        </span>
      </button>
    </div>
  }
</div>
@if (isBusy()) {
  <div class="busyIndicator">
    <div class="busyContents">
      <mat-progress-spinner diameter="48" mode="indeterminate"></mat-progress-spinner>
      <label class="busyLabel">Please Wait...</label>
    </div>
  </div>
}
